//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ObjectFunc = require('@/tbs/util/ObjectFunc')

/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchSignupTeamConfig = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSignupTeamConfig.prototype = {
    /* The view object name */
    name: 'matchGroup',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetBMMatchTeamSignupSetting',
            query: {
                matchId: 'id',
            },
            basePath: 'data',
            rule: {
                id: '$id',
                isTeamNameChecked: '@name',
                isTeamShortNameChecked: '@teamAlias',
                isTeamContactChecked: '@contactPerson',
                isTeamContactPhoneChecked: '@contactNumber',
                isTeamEmblemChecked: '@badge',
                isTeamDelegationChecked: '@delegation',
                isTeamHomeColorChecked: '@homeColor',
                isTeamAwayColorChecked: '@awayColor',
                isTeamContestColorChecked: '@clothesColorDescription',
                isTeamSuitStyleChecked: '@clothesId',
                isTeamInsuranceChecked: '@insurancePolicy',
                teamDelegationItems: '$teamDelegations',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMMatchTeamSignupSetting',
            basePath: '',
            rule: {
                matchId: 'id',
                name: '(1)',
                teamAlias: '#isTeamShortNameChecked',
                contactPerson: '#isTeamContactChecked',
                contactNumber: '#isTeamContactPhoneChecked',
                badge: '#isTeamEmblemChecked',
                delegation: '$isTeamDelegationChecked,teamDelegationItems',
                homeColor: '#isTeamHomeColorChecked',
                awayColor: '#isTeamAwayColorChecked',
                clothesColorDescription: '#isTeamContestColorChecked',
                clothesId: '#isTeamSuitStyleChecked',
                insurancePolicy: '#isTeamInsuranceChecked',
                teamDelegations: '$teamDelegationItems'
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderId: function(id, options) {
        return options.parameters.matchId
    },
    formatDelegation: function(isTeamDelegationChecked, teamDelegationItems) {
        if (isTeamDelegationChecked && ObjectFunc.convertSelectedItemArray2String(teamDelegationItems).length > 0) {
            return 1
        }
        return 0
    },
    formatTeamDelegations: function(teamDelegationItems) {
        return ObjectFunc.convertSelectedItemArray2String(teamDelegationItems)
    },
    renderTeamDelegationItems: function(teamDelegations) {
        teamDelegations = teamDelegations || ''
        const itemArr = teamDelegations.split(',')
        const items = []
        for (let i = 0; i < itemArr.length; i++) {
            let item = itemArr[i]
            if (item) {
                items.push({
                    label: item,
                    selected: true
                })
            }     
        }
        return items
    },
}

module.exports = tbs_model_vo_MatchSignupTeamConfig